import { FC } from 'react';

import { Box } from '@mantine/core';

const EIcon: FC<{ width?: number; height?: number }> = ({ width, height }) => {
    return (
        <Box component="svg" viewBox="0 0 360 252" width={width} height={height}>
            <style>
                {`.st0{fill:#FFFFFF;}
                .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
                .st2{fill:#26A9E0;}
                .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#26A9E0;}
                .st4{fill-rule:evenodd;clip-rule:evenodd;}
                .st5{fill-rule:evenodd;clip-rule:evenodd;fill:#EDEDED;}
                .st6{opacity:0.15;}
                .st7{opacity:0.08;}
                .st8{fill-rule:evenodd;clip-rule:evenodd;fill:#404041;}`}
            </style>
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    className="st4"
                                    d="M66.9,79h226.2l14.1-28.2L81,50.7L66.9,79z M97.5,173h193.4l-14.1,28.2H97.5c-24.7,0-44.7-20-44.7-44.7
                                    c0-24.7,20-44.7,44.7-44.7h35.3l-14.1,28.2H97.5c-9.1,0-16.5,7.4-16.5,16.5C81,165.7,88.4,173,97.5,173z"
                                />
                            </g>
                        </g>
                        <polygon className="st3" points="143.5,140.1 157.6,111.9 204.7,111.9 190.6,140.1 " />
                        <polygon className="st3" points="215.5,140.1 229.6,111.9 276.6,111.9 262.5,140.1 " />
                    </g>
                </g>
            </g>
        </Box>
    );
};

export { EIcon };
